// extracted by mini-css-extract-plugin
export default {"setting--inverted":"pNeTq__","dark-theme":"yfwq8zg","avatar":"RqPp5et","clickable":"dvybPKy"};